export enum UserRoles {
    admin = 'admin',
    editor = 'editor',
    user = 'user',
    tester = 'tester'
}
